export default () => {
  return {
    sanitizeWebsiteDomain (value) {
      if (!value) return value

      value = value.toLowerCase()

      const matches = value.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i)
      if (matches && matches[1]) {
        return matches[1].trim()
      } else {
        return value.trim()
      }
    },
    sanitizeKeywordName (value, noTrim) {
      if (!value) return value

      value = value.toLowerCase()
      value = value.replace('’', '\'')
      // value = value.replace(/[^0-9a-záàâäȧāãçéèêëęíîïīłƚṇñóôöøɵōõšṣẗţṭúùûüÿžżẓæœаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯαβγδεζηθικλμνξοπρστυφχψω \-().?!#@$€'&]/g, '')
      if (noTrim) return value
      else return value.trim()
    }
  }
}
